import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/aiLineage/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/aiLineage/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/aiLineage/FETCH_FAILURE'

const CHILDREN_REQUEST = 'contenthouse/aiLineage/CHILDREN_REQUEST'
const CHILDREN_SUCCESS = 'contenthouse/aiLineage/CHILDREN_SUCCESS'
const CHILDREN_FAILURE = 'contenthouse/aiLineage/CHILDREN_FAILURE'

// CH-4304: per-asset AI lineage (the base a post-prod AI asset was generated from) and the
// reverse read (the children a base has produced). Null/[] = none — cached per asset id.
const initialState = {
  data: {},
  children: {},
  errors: [],
  loaded: false,
  loading: false,
}

export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(assetId, lineage){
  return {
    type: FETCH_SUCCESS,
    assetId,
    lineage,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function loadAiLineage(assetId){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api(`/v1/assets/${assetId}/ai-lineage`, {})
      .then(({ data }) => {
        dispatch(fetchSuccess(assetId, data))

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function childrenRequest(){
  return {
    type: CHILDREN_REQUEST,
  }
}

export function childrenSuccess(assetId, children){
  return {
    type: CHILDREN_SUCCESS,
    assetId,
    children,
  }
}

export function childrenFailure(errors = []){
  return {
    type: CHILDREN_FAILURE,
    errors,
  }
}

// CH-4304: the AI assets derived from a base — feeds the Base row's child links.
export function loadAiChildren(assetId){
  return (dispatch) => {
    dispatch(childrenRequest())

    const promise = api(`/v1/assets/${assetId}/ai-children`, {})
      .then(({ data }) => {
        dispatch(childrenSuccess(assetId, data || []))

        return { success: true, data: data || [] }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(childrenFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
        data: {
          ...state.data,
          [action.assetId]: action.lineage,
        },
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.errors,
      }
    case CHILDREN_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case CHILDREN_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: [],
        children: {
          ...state.children,
          [action.assetId]: action.children,
        },
      }
    case CHILDREN_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
